import request from "@/utils/request";

export function queryList (data){
  return request({
    url:'/osp/matAhead/queryList' ,
    method:'post',
    data: data
  })
}

export function saveBo (data) {
  return request({
    url: '/osp/matAhead/saveBo',
    method: 'post',
    data: data
  })
}


